import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { Clock, Users, Star } from 'lucide-react';

const programs = [
  {
    title: "Creative Arts",
    description: "Unleash creativity through painting, drawing, and crafts that develop fine motor skills.",
    image: "https://images.unsplash.com/photo-1611085667203-7efa7c067bce?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMGFydCUyMGNyZWF0aXZlfGVufDF8fHx8MTc1NjkyNTg0MXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    duration: "45 mins",
    groupSize: "6-8 kids",
    rating: 4.9,
    color: "bg-pink-500"
  },
  {
    title: "Reading Adventures",
    description: "Build reading skills through storytelling, phonics, and interactive book activities.",
    image: "https://images.unsplash.com/photo-1549737221-bef65e2604a6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGlsZCUyMHJlYWRpbmclMjBib29rfGVufDF8fHx8MTc1NjkyNTg0MXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    duration: "30 mins",
    groupSize: "4-6 kids",
    rating: 5.0,
    color: "bg-blue-500"
  },
  {
    title: "Science Explorers",
    description: "Discover the wonders of science through hands-on experiments and observations.",
    image: "https://images.unsplash.com/photo-1574132190990-cfd62178bb1c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxraWRzJTIwY2xhc3Nyb29tJTIwbGVhcm5pbmd8ZW58MXx8fHwxNzU2OTA3NDU3fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    duration: "60 mins",
    groupSize: "8-10 kids",
    rating: 4.8,
    color: "bg-green-500"
  }
];

export function Programs() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="bg-purple-100 text-purple-600 px-4 py-2 rounded-full text-sm font-medium">
            Our Programs
          </span>
          <h2 className="text-4xl font-bold text-gray-800 mt-4 mb-6">
            Learning Programs for Every Child
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Carefully designed programs that cater to different interests and developmental stages, 
            ensuring every child finds their passion.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program, index) => (
            <Card key={index} className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <ImageWithFallback
                  src={program.image}
                  alt={program.title}
                  className="w-full h-48 object-cover"
                />
                <div className={`absolute top-4 right-4 ${program.color} text-white px-3 py-1 rounded-full text-sm font-medium`}>
                  New
                </div>
              </div>
              
              <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex items-center text-sm text-gray-500">
                    <Clock className="w-4 h-4 mr-1" />
                    {program.duration}
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <Users className="w-4 h-4 mr-1" />
                    {program.groupSize}
                  </div>
                  <div className="flex items-center text-sm text-yellow-500">
                    <Star className="w-4 h-4 mr-1 fill-current" />
                    {program.rating}
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-3">{program.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{program.description}</p>
                
                <Button className="w-full bg-orange-400 hover:bg-orange-500 text-white rounded-full">
                  Learn More
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}